/**
 * @desc Controller for the csTimeline directive
 */
;(function () {
  angular
    .module('contrast.timeline')
    .controller('csTimelineCtrl', csTimelineCtrl)

  function csTimelineCtrl($window, $compile, $timeout, d3, csTimelineChart) {
    'ngInject'

    var vm = this,
      scope = null,
      config = {},
      data = [],
      chart = null,
      svg = null,
      parentEl = null,
      containerEl = null

    vm.activate = activate

    function activate(dirScope, parent, timelineContainer) {
      scope = dirScope
      parentEl = parent
      containerEl = timelineContainer

      data = scope.csTimelineData
      config = scope.csTimelineConfig

      chart = csTimelineChart.createChart()

      var configProps = csTimelineChart.getConfigurableProperties()

      for (var i = 0; i < configProps.length; i++) {
        var propName = configProps[i]
        if (config && angular.isDefined(config[propName])) {
          chart[propName](config[propName])
        }
      }

      svg = d3
        .select(timelineContainer[0])
        .append('svg')
        .attr('width', parentEl.width())
        .datum(data)
        .call(chart)

      $window.addEventListener('resize', function () {
        render()
      })

      scope.$watch(
        function () {
          return parentEl.width() + containerEl.width()
        },
        function (newValue, oldValue) {
          if (newValue && newValue !== oldValue) {
            render()
          }
        }
      )

      scope.$watch('csTimelineShow', function (newVal, oldValue) {
        if (newVal && newVal !== oldValue) {
          $timeout(function () {
            render()
          }, 10)
        }
      })

      render()
    }

    function render() {
      var containerWidth = parentEl.width()
      var containerHeight = parentEl.height()

      svg.attr('width', containerWidth)
      svg.attr('height', containerHeight)
      chart.update(containerWidth, containerHeight)
      $compile(containerEl)(scope)
    }
  }
})()
